import { render, staticRenderFns } from "./CreateDonorIdentification.vue?vue&type=template&id=9bf5d0ae"
import script from "./CreateDonorIdentification.vue?vue&type=script&lang=js"
export * from "./CreateDonorIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports